import { useFetch } from "../../hooks/useFetch";
import LoadSimple from "../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteUSer from "./ModalDeleteUser";
import ModalCloseUser from "./ModalCloseUser";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const PortafolioList = ({
  pageActual,
  limitList,startLimit,
  dataList,
  devices,
  setEditActive,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  cisSelected,
  setCisSelected,
  exceptions,
  languaje,
  mode
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [closeUserModalOpen, setCloseUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  function openCloseUserModal() {
    setCloseUserModalOpen(true);
  }

  function closCloseUserModal() {
    setCloseUserModalOpen(false);
  }
  const handlecloseUserClick = (data) => {
        
    openCloseUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  useEffect(() => {
    buscar_cis();
  }, []);
  const buscar_cis = () => {
    // setLoadingCis(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/exceptions/list/detail",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };
  const delteException=(elemento)=>{

  }
  const editException=(elemento)=>{

  }
  return (
    <>
      <div className="cont-row-user-list">
        {dataUsers.loading ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={indice}
              >
                <div className="field-body-table-mantenimiento field-medium">
                  {elemento.exception_id}
                </div>
                <div className="field-body-table-mantenimiento field-larger">
                  {elemento.hostid}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'40%'}}>
                  {elemento.host}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                  {elemento.description}
                </div>
                <div className="field-body-table-mantenimiento field-larger">
                  {elemento.name}
                </div>
                <div className="field-body-table-mantenimiento field-larger">
                  {elemento.active_time}
                </div>
                <div className="field-body-table-mantenimiento field-larger">
                  <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/editar.png"
                    } 
                    onClick={()=>handleChangEdit(elemento)}
                    name="Editar" title="Editar" className="btnAction delteException" style={{width:'30%'}}
                  />
                  </div>
                  <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/cerrar.png"
                    } 
                    onClick={()=>handlecloseUserClick(elemento)}
                    name="Cerrar"  title='Cerrar' className="btnAction delteException" style={{width:'30%'}}
                  />
                  </div>
                  <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/delete.png"
                    } 
                    onClick={()=>handledeleteUserClick(elemento)}
                    name="Eliminar"  title='Eliminar' className="btnAction delteException" style={{width:'30%'}}
                  />
                  </div>
                  
                </div>
              </div>
            ))
        )}
        {dataUsers.loading == false && dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={closeUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closCloseUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalCloseUser languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closCloseUserModal={closCloseUserModal}></ModalCloseUser>
    </Modal>
    <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteUSer languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteUSer>
    </Modal>
    </>
  );
};

export default PortafolioList;
